import React from "react";
import {Alert, Card, Col, Row} from "react-bootstrap";
import {formatNumber} from "../Statistics/format.js";
import {formatDateTimeDE, formatDuration} from "./format.js";

const FELDER = [
    {key: "aktive_sekunden", label: "Aktive Zeit", format: formatDuration},
    {key: "anwesend_sekunden", label: "Anwesenheit", format: formatDuration},
    {key: "aktionen", label: "Aktionen", format: formatNumber},
    {key: "aenderungen", label: "Änderungen", format: formatNumber},
    {key: "sitzungen", label: "Sitzungen", format: formatNumber},
    {key: "letzte_anmeldung", label: "Letzte Anmeldung", format: formatDateTimeDE},
];

/**
 * Kennzahlen-Kacheln des Profils - dieselben Feldnamen wie in der
 * Mitarbeitertabelle (siehe NutzungMitarbeiterTabelle), weil das
 * "kennzahlen"-Objekt aus /nutzung/daten/profil/{user} fachlich dieselbe
 * Zeile für genau einen Mitarbeiter ist. Ladezustand/Leerfall wie überall
 * in der Nutzungsauswertung: während des Ladens und wenn wirklich nichts
 * geliefert wird, bleibt die Zeile ganz weg.
 */
export default function NutzungProfilKennzahlen({data, loading, error}) {
    if (loading) {
        return null;
    }
    if (error) {
        return <Alert variant="danger" className="mb-0">{error}</Alert>;
    }
    if (!data) {
        return null;
    }

    return (
        <Row xs={1} sm={2} lg={6} className="g-3">
            {FELDER.map((feld) => (
                <Col key={feld.key}>
                    <Card className="h-100 shadow-sm">
                        <Card.Body>
                            <div className="text-muted small text-uppercase">{feld.label}</div>
                            <div className="fs-5 fw-semibold lh-sm mt-1">{feld.format(data[feld.key])}</div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
}
